<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <BaseInput :options="titleInput.options" :data="titleInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6">
                  <BaseSelect :options="statusSelect.options" :data="statusSelect.data"
                              ref="statusSelect"></BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                  <BaseTextArea :options="htmlInput.options" :data="htmlInput.data"
                                v-model="htmlInput.data.model"/>
                </CCol>
                <CCol xs="12" sm="12" md="12" lg="12" xl="12">
                  <BaseTextArea :options="scriptInput.options" :data="scriptInput.data"
                                v-model="scriptInput.data.model"/>
                </CCol>
                <CCol xs="3" sm="3" md="3" lg="3" xl="3">
                  <div class="file-upload">
                    <!-- <button class="file-upload-btn" type="button"
                        onclick="$('.file-upload-input').trigger( 'click' )">Thêm logo</button> -->

                    <div class="image-upload-wrap">
                      <input class="file-upload-input" type='file' ref="file"
                             @change="selectFile($event)" accept="image/*"/>
                      <div class="drag-text">
                        <h3>Chọn logo tiện ích</h3>
                      </div>
                    </div>
                    <div class="file-upload-content"
                         onclick="$('.file-upload-input').trigger( 'click' )">
                      <img class="file-upload-image" src="#" alt="your image"/>
                      <!-- <div class="image-title-wrap">
                          <button type="button" onclick="removeUpload()"
                              class="remove-image">Gỡ logo</button>
                      </div> -->
                    </div>
                  </div>
                  <div class="valid-error"
                       v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                    {{
                      selectedFiles.data.validator ?
                        selectedFiles.data.validator.errorMessage : ""
                    }}
                  </div>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData">
                  <i class="fa fa-refresh"></i> Cập nhật
                </CButton>
                <CButton color="secondary" class="btn-action-primary" @click="$router.go(-1)"><i
                  class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import BaseTextArea from "../base/BaseTextArea.vue";
import {FILE_MAX_SIZE, IS_CHECK_MAX_SIZE_UPLOAD} from "@/constant";

export default {
  name: "WidgetUpdate",
  components: {BaseSelect, BaseInput, BaseLoading, BaseTextArea},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      acceptFile: ".png,.jpg,.jpeg",
      fileName: "Chọn tệp",
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id",
        },
      },

      titleInput: {
        options: {
          label: "Tên tiện ích <span class='required'>*</span>",
          placeholder: "Tên tiện ích",
          maxlength: 256
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiện ích không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      selectedFiles: {
        data: {
          loading: false,
          name: "file",
          model: {
            fileName: '',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              this.isValid = that.validateFile();
              return this.isValid;
            }
          }
        }
      },
      htmlInput: {
        options: {
          label: "HTML <span class='required'>*</span>",
          placeholder: "HTML",
          rows : 5
        },
        data: {
          name: "html",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.htmlInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "HTML không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      scriptInput: {
        options: {
          label: "Script",
          placeholder: "Script",
          rows : 10
        },
        data: {
          name: "script",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              // let value = that.scriptInput.data.model;
              // if (value === "") {
              //     this.isValid = false;
              //     this.errorMessage = "Script không được để trống";
              // } else {
              //     this.isValid = true;
              // }
              return this.isValid;
            }
          }
        }
      },
      statusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "isActive",
          items: [
            // {key: "null", value: "Tất cả trạng thái"},
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Vô hiệu hóa"},
          ],
          model: "1",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
    }
  },
  methods: {
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      isValid &= this.selectedFiles.data.validator.valid();
      isValid &= this.htmlInput.data.validator.valid();
      isValid &= this.scriptInput.data.validator.valid();
      if (!isValid) {
        return;
      }
      that.loading.value = true;
      let formData = new FormData();
      formData.append("id", that.idField.data.model);
      formData.append("title", that.titleInput.data.model);
      formData.append("html", that.htmlInput.data.model);
      formData.append("script", that.scriptInput.data.model);
      formData.append("isActive", that.statusSelect.data.model);
      if (that.$refs.file.files[0]) {
        formData.append("file", that.$refs.file.files[0]);
      }

      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/widget/update",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới tiện ích thành công"
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (file && file.files[0]) {
        file = file.files[0];
        this.selectedFiles.data.loading = true;

        reader.readAsDataURL(file);

        reader.onload = function (e) {
          // console.log(file)
          that.fileName = file.name;
          that.selectedFiles.data.model.size = file.size;
          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.type = file.type;
          let isValid = that.validateFile();
          if (isValid) {
            $('.image-upload-wrap').hide();

            $('.file-upload-image').attr('src', e.target.result);
            $('.file-upload-content').show();

            // $('.image-title').html(file.name);
          }
        }
        reader.onloadend = function () {
          that.selectedFiles.data.loading = false;
        }
      } else {
        // removeUpload();
      }
    },
    validateFile() {
      let isValid = true;
      if (this.selectedFiles.data.model.fileName === '') {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Logo tiện ích không được để trống";
        isValid = false;
      }

      if (isValid) {
        isValid = this.validateFileType();
      }

      return isValid;
    },
    validateFileType() {
      let isValid = true;
      let fileType = this.selectedFiles.data.model.type;
      if (this.selectedFiles.data.model.size > FILE_MAX_SIZE && IS_CHECK_MAX_SIZE_UPLOAD) {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Tệp tin không được quá 200MB";
        isValid = false;
      } else if (fileType === "image/jpeg" || fileType === "image/png" || fileType === "image/jpg") {
        this.selectedFiles.data.validator.isValid = true;
        this.selectedFiles.data.validator.errorMessage = "";
      } else {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Sai định dạng bản tin";
        isValid = false;
      }
      return isValid;
    },
    loadData() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/widget/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: that.idField.data.model};
        },
        successCallback: function (response) {
          // that.$helper.setupDataResponse(that.$data, response.data.data);
          if (response.data.data.isActive) {
            that.statusSelect.data.model = "1"
          } else {
            that.statusSelect.data.model = "0"
          }
          that.htmlInput.data.model = response.data.data.html;
          that.scriptInput.data.model = response.data.data.script;
          that.titleInput.data.model = response.data.data.title;
          if (response.data.data.urlThumbnail != null && response.data.data.urlThumbnail.length > 0) {
            var fileName = response.data.data.urlThumbnail.substring(response.data.data.urlThumbnail.lastIndexOf("/") + 1, response.data.data.urlThumbnail.length);
            that.selectedFiles.data.model.fileName = fileName;
            that.selectedFiles.data.model.type = "image/" + fileName.split(".")[1];
            $('.image-upload-wrap').hide();

            $('.file-upload-image').attr('src', response.data.data.urlThumbnail);
            $('.file-upload-content').show();

            // $('.image-title').html(that.selectedFiles.data.model.fileName);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },

  },
  computed: {},
  created() {
  },
  mounted() {
    this.loadData();
    this.fileName = 'Chọn tệp';
  },
  watch: {}
};
</script>

<style scoped>
body {
  /* font-family: sans-serif; */
  background-color: #eeeeee;
}

.file-upload {
  background-color: #ffffff;
  width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.file-upload-btn {
  width: 100%;
  margin: 0;
  color: #fff;
  background: #1FB264;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #15824B;
  transition: all .2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
}

.file-upload-btn:hover {
  background: #1AA059;
  color: #ffffff;
  transition: all .2s ease;
  cursor: pointer;
}

.file-upload-btn:active {
  border: 0;
  transition: all .2s ease;
}

.file-upload-content {
  display: none;
  text-align: center;
}

.file-upload-input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
  cursor: pointer;
}

.image-upload-wrap {
  margin-top: 20px;
  border: 4px dashed #1FB264;
  position: relative;
}

.image-dropping,
.image-upload-wrap:hover {
  background-color: #1FB264;
  border: 4px dashed #ffffff;
}

.image-title-wrap {
  padding: 0 15px 15px 15px;
  color: #222;
}

.drag-text {
  text-align: center;
}

.drag-text h3 {
  font-weight: 100;
  text-transform: uppercase;
  color: #15824B;
  padding: 60px 0;
}

.file-upload-image {
  max-height: 200px;
  max-width: 200px;
  margin: auto;
  padding: 20px;
}

.remove-image {
  width: 200px;
  margin: 0;
  color: #fff;
  background: #cd4535;
  border: none;
  padding: 10px;
  border-radius: 4px;
  border-bottom: 4px solid #b02818;
  transition: all .2s ease;
  outline: none;
  text-transform: uppercase;
  font-weight: 700;
}

.remove-image:hover {
  background: #c13b2a;
  color: #ffffff;
  transition: all .2s ease;
  cursor: pointer;
}

.remove-image:active {
  border: 0;
  transition: all .2s ease;
}
</style>
